const PREFIX_DEFAULT = 'adm-cabinet-table-'
const POSTFIX_PAGESIZE = '-pageSize'

export { PREFIX_DEFAULT, POSTFIX_PAGESIZE }
